// Share link and LINE in-app browser (same idiom as name-tag's / pet-tag's src/share.js). PURE:
// strings in, strings out — src/main.js does the DOM. The design travels in the URL FRAGMENT
// (`#s=…`): a fragment is never sent to the server.
import { encodeFragment, decodeFragment } from './doc.js';

const KEY = 's';

// The link for a document: the page's own address (path and query kept, any old fragment replaced).
export function shareUrl(href, doc) {
  const u = new URL(href);
  u.hash = `${KEY}=${encodeFragment(doc)}`;
  return u.toString();
}

// location.hash → null (no share link in it) | { doc } | { error: { code } }.
// A link is input from strangers: everything about judging it is decodeFragment()'s job (src/doc.js).
export function readShare(hash) {
  const m = /^#?s=(.*)$/s.exec(String(hash ?? ''));
  return m ? decodeFragment(m[1]) : null;
}

// LINE's in-app browser names itself "Line/<version>" in the user agent (iOS and Android). Downloads
// do not work there, so the page offers LINE's own way out: the same URL with
// ?openExternalBrowser=1 opens in the phone's normal browser.
export const isLineBrowser = (userAgent) => /(^|[\s;(])Line\/\d/.test(String(userAgent ?? ''));

// Same page, same query, same FRAGMENT (the design must survive the hop) + openExternalBrowser=1.
export function externalBrowserUrl(href) {
  const u = new URL(href);
  u.searchParams.set('openExternalBrowser', '1');
  return u.toString();
}
